import { createId } from './id.js';
export const createIsOnline = options => {
  const id = createId(options);
  async function isOnline(options = {}) {
    const res = await id(options);
    return Boolean(res && res.addresses && res.addresses.length);
  }
  return isOnline;
};